import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function ProductShowcase() {
  return <section className="pt-20 pb-12 px-4 bg-brand-dark text-white" data-id="element-245">
      <div className="max-w-4xl mx-auto text-center" data-id="element-246">
        <div className="inline-flex items-center justify-center gap-2 bg-brand-primary/20 text-brand-secondary font-bold px-4 py-2 rounded-full mb-6 border border-brand-primary/30" data-id="element-247">
          <span data-id="element-248">❄️</span> EL SISTEMA DEFINITIVO
        </div>

        <h2 className="text-4xl md:text-6xl font-black mb-4" data-id="element-249">
          PACK COMPLETO DE REFRIGERACIÓN
        </h2>

        <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto mb-12 font-medium" data-id="element-250">
          5 Módulos Maestros con todo lo que necesitás para trabajar y cobrar
          desde el primer día.
        </p>

        <div className="flex flex-wrap justify-center gap-4 mb-12" data-id="element-251">
          {['M1', 'M2', 'M3', 'M4', 'M5'].map(modulo => <div key={modulo} className="w-16 h-16 bg-slate-800 rounded-xl shadow-md flex items-center justify-center text-2xl font-black text-brand-primary border-2 border-slate-700" data-id="element-252">
              {modulo}
            </div>)}
        </div>

        <div className="bg-slate-800 p-8 md:p-10 rounded-3xl shadow-2xl border border-slate-700 text-left max-w-2xl mx-auto" data-id="element-253">
          <h4 className="text-2xl font-black text-white mb-6 border-b border-slate-600 pb-4 text-center" data-id="element-254">
            ¿QUÉ VAS A LOGRAR?
          </h4>
          <ul className="space-y-5" data-id="element-255">
            {['Instalar equipos desde cero con seguridad', 'Diagnosticar fallas sin perder tiempo', 'Reparar aires, heladeras y automotor', 'Presupuestar y cobrar como un profesional', 'Conseguir clientes todo el año'].map((item, i) => <li key={i} className="flex items-center gap-4 text-xl font-bold text-gray-200" data-id="element-256">
                <CheckCircleIcon className="w-8 h-8 text-brand-primary flex-shrink-0" data-id="element-257" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}